export default __webpack_public_path__ + "cc1aa8314a46643a3364a9a750466580.svg";